import { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'tp360_cookie_consent';

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[100] animate-in fade-in slide-in-from-bottom-4"
      data-testid="cookie-notice"
    >
      <div className="bg-[#13131a]/95 backdrop-blur-lg border border-white/10 rounded-lg shadow-2xl p-4 flex items-start gap-3">
        <div className="w-8 h-8 bg-blue-500/10 rounded-full flex items-center justify-center flex-shrink-0">
          <Cookie className="w-4 h-4 text-blue-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-200 leading-relaxed">
            We use cookies and analytics to improve user experience and platform performance. By
            continuing to use this website, you agree to our{' '}
            <Link
              to="/privacy"
              className="text-blue-400 hover:text-blue-300 underline"
              data-testid="cookie-notice-privacy-link"
            >
              Privacy Policy
            </Link>
            .
          </p>
          <div className="mt-3 flex items-center gap-2">
            <button
              onClick={accept}
              className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded transition-colors"
              data-testid="cookie-notice-accept"
            >
              Accept
            </button>
            <Link
              to="/privacy"
              className="px-3 py-1.5 text-gray-400 hover:text-white text-xs font-semibold transition-colors"
              data-testid="cookie-notice-learn-more"
            >
              Learn more
            </Link>
          </div>
        </div>
        <button
          onClick={accept}
          className="text-gray-500 hover:text-gray-300 transition-colors flex-shrink-0"
          aria-label="Dismiss"
          data-testid="cookie-notice-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
